export enum EducatorTier {
  STAR = "star",
  NEW_ON_OUTSCHOOL = "new_on_outschool",
  POPULAR = "popular",
  RISING_STAR = "rising_star",
}

export const EducatorTierValues = Object.values(EducatorTier);

export function isEducatorTier(input: any): input is EducatorTier {
  return EducatorTierValues.includes(input);
}
